export default "__VITE_ASSET__0CsOkWG$__"